/**
 * QuantumOS Dashboard
 *
 * React application entry point.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";


const rootElement =
  document.getElementById("root");


if (!rootElement) {
  throw new Error(
    "QuantumOS dashboard root element was not found.",
  );
}


createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);